export const GET_GROUP_STUDENTS_SUCCESS = 'GET_GROUP_STUDENTS_SUCCESS';
export const SET_FILTERS_STUDENTS = 'SET_FILTERS_STUDENTS';
export const SET_FETCHING_STUDENTS = 'SET_FETCHING_STUDENTS'